"use client";

import { TGridCard } from "@shared/cms";
import Image from "next/image";
import Link from "next/link";
import Markdown from "react-markdown";

export function GridCard({ title, cardNumber, description, image }: TGridCard) {
  return (
    <div>
      {image && (
        <Image
          src={image.url}
          alt={image.alternativeText || image.name}
          width={image.width || 280}
          height={image.height || 260}
          className="w-full mx-auto mb-6"
        />
      )}
      <div className="text-center">
        {cardNumber && (
          <div className="size-10 mx-auto bg-gray-700 text-white rounded-full flex items-center justify-center mb-6">{cardNumber}</div>
        )}
        <div className="space-y-3">
          <div className="text-lg sm:text-xl font-bold text-gray-700">{title}</div>
          {description && (
            <div className="text-base text-gray-500">
              <Markdown
                components={{
                  a(props) {
                    return (
                      <Link className="text-primary font-medium" {...props} href={props.href as string}>
                        {props.children}
                      </Link>
                    );
                  },
                }}
              >
                {description}
              </Markdown>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
